(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  let observer;
  function init() {
    observer?.disconnect();
    const section = document.querySelector('[data-product-section]');
    const bar = section?.querySelector('[data-mobile-buy-bar]');
    const form = section?.querySelector('.product-form');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => { bar.hidden = entries[0].isIntersecting; }, { threshold: 0 });
    observer.observe(form);
  }
  init();
  document.addEventListener('coeda:product-updated', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', event => {
    const link = event.target.closest('.mobile-buy-link');
    if (!link) return;
    const form = link.closest('[data-product-section]').querySelector('.product-form');
    if (!form) return;
    event.preventDefault();
    form.scrollIntoView({ block: 'start', behavior: 'auto' });
    form.querySelector('[data-option-link], [data-add-to-cart]')?.focus({ preventScroll: true });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
